import { render, staticRenderFns } from "./BuyUse.vue?vue&type=template&id=15e2830e&scoped=true&"
import script from "./BuyUse.vue?vue&type=script&lang=js&"
export * from "./BuyUse.vue?vue&type=script&lang=js&"
import style0 from "./BuyUse.vue?vue&type=style&index=0&id=15e2830e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2830e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VApp,VDataTable})
